import {
  BookmarksOutlined,
  Dashboard,
  Home,
  InfoOutlined,
  ListAlt,
  ManageSearch,
  Search,
  LocalActivity as TokenIcon,
} from '@mui/icons-material';
import { List } from '@mui/material';
import { useState } from 'react';

import { useFeatureToggle } from '@/featureToggles/FeatureTogglesContext';
import { UserLevel } from '@/types';
import { NavBarLink } from '@australiangreens/ag-internal-components';
import HelpDialog from '@components/HelpDialog';

interface NavBarMiddleContentProps {
  userLevel?: UserLevel;
  isSmallScreen?: boolean;
}

export const NavBarMiddleContent = ({ userLevel, isSmallScreen }: NavBarMiddleContentProps) => {
  const devToolsEnabled = useFeatureToggle('Developer Features');
  const [dialogHelpOpen, setdialogHelpOpen] = useState(false);

  return (
    <>
      <List disablePadding>
        <NavBarLink
          label="Home"
          to="/"
          icon={<Home />}
          closeOnSmallScreen={true}
          tooltipMenuClosed="Home"
        />

        {['Coordinator', 'Principal Coordinator'].includes(userLevel ?? 'None') &&
          !isSmallScreen && (
            <>
              <NavBarLink
                label="Quick Search"
                to={'/quicksearch'}
                icon={<Search />}
                closeOnSmallScreen={true}
                tooltipMenuClosed="Quick Search"
              />

              <NavBarLink
                label="Advanced Search"
                to={'/advancedsearch'}
                icon={<ManageSearch />}
                closeOnSmallScreen={true}
                tooltipMenuClosed="Advanced Search"
              />
              <NavBarLink
                label={'Search Library'}
                to={'/searchlibrary'}
                icon={<BookmarksOutlined />}
                closeOnSmallScreen={true}
                tooltipMenuClosed="Search Library"
              />
            </>
          )}

        <NavBarLink
          label="Lists"
          to={'/lists'}
          icon={<ListAlt />}
          closeOnSmallScreen={true}
          tooltipMenuClosed="Lists"
        />

        <NavBarLink
          label="About"
          icon={<InfoOutlined />}
          closeOnSmallScreen={true}
          onClick={() => setdialogHelpOpen(true)}
          tooltipMenuClosed="About"
        />

        {devToolsEnabled && (
          <NavBarLink label="Token" to="/token" icon={<TokenIcon />} tooltipMenuClosed="Token" />
        )}
        {devToolsEnabled && (
          <NavBarLink
            label="Superset"
            to="/superset"
            icon={<Dashboard />}
            tooltipMenuClosed="Superset"
          />
        )}
      </List>

      <HelpDialog
        open={dialogHelpOpen}
        onClose={async () => setdialogHelpOpen(false)}
        aria-labelledby="about-dialog"
        aria-describedby="about-dialog"
      />
    </>
  );
};
